import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-68cadf1c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "news-list"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "banner"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "common"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "新闻中心")])], -1));
const _hoisted_3 = {
  class: "main"
};
const _hoisted_4 = {
  class: "common"
};
const _hoisted_5 = {
  class: "list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "center"
};
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = {
  class: "text"
};
const _hoisted_10 = {
  class: "time"
};
import news from '@/views/home/news';
import { ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
export default {
  __name: 'news-list',
  setup(__props) {
    const router = useRouter();
    const tab = ref('first');
    const page = reactive({
      pageNum: 1,
      pageSize: 10,
      total: 3
    });
    const loading = ref(false);
    const tabClick = tab => {};
    const handleSizeChange = size => {};
    const handleCurrentChange = num => {};
    const clickNewsItem = index => {
      router.push({
        path: `/news-detail/${index}`
      });
    };
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_pagination = _resolveComponent("el-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_tabs, {
        class: "tabs",
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => tab.value = $event),
        onTabClick: tabClick
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "新闻动态",
          name: "first"
        }, {
          default: _withCtx(() => [_createElementVNode("ul", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(news), (item, index) => {
            return _openBlock(), _createElementBlock("li", {
              key: index,
              class: "item",
              onClick: $event => clickNewsItem(index)
            }, [_createElementVNode("b", {
              class: "img bak",
              style: _normalizeStyle(`background-image: url(${item.img})`)
            }, null, 4), _createElementVNode("div", _hoisted_7, [_createElementVNode("h3", _hoisted_8, _toDisplayString(item.title), 1), _createElementVNode("p", _hoisted_9, _toDisplayString(item.desc), 1)]), _createElementVNode("span", _hoisted_10, _toDisplayString(item.time), 1)], 8, _hoisted_6);
          }), 128))])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_pagination, {
        class: "pagination",
        "current-page": page.pageNum,
        "onUpdate:current-page": _cache[1] || (_cache[1] = $event => page.pageNum = $event),
        "page-size": page.pageSize,
        "onUpdate:page-size": _cache[2] || (_cache[2] = $event => page.pageSize = $event),
        "page-sizes": [5, 10, 20, 30],
        small: false,
        disabled: false,
        layout: "total, sizes, prev, pager, next, jumper",
        total: page.total,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "total"])])])]);
    };
  }
};